import { createFileRoute } from '@tanstack/react-router';
import { InviteForm } from '@/features/auth/invite-form';

export const Route = createFileRoute('/_public/invite/$token')({
  component: InvitePage,
});

function InvitePage() {
  const { token } = Route.useParams();
  return <InviteForm token={token} />;
}
